import actions from "@components/Redux/Category/actions";
import globalActions from "@components/Redux/Global/actions";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import useSafePush from "../useSafePush";


const useCategoryShallowLink = () => {

    const router = useRouter();
    const dispatch = useDispatch();
    // const {setPageSpinner} = useGeneralActions();

    const template_settings = useSelector(state => state.globalReducer.template_settings);
    const categoryState = useSelector(state => state.categoryReducer.categoryState);
    const getProducts = async (route, page = null) => {
        let pageStr = page == null ? '' : `&page=${page}`;
        const req = await fetch(`${process.env.BASE_API_URL}get-category?slug=${route}${pageStr}`); //find the category data from the url
        const data = await req.json();
        return data;
    }

    const { safePush } = useSafePush();

    const handleShallowLink = async (e, route, staticPage = false, options = {}) => {
        const cleanOptions = { ...options };

        if (cleanOptions.page == 1) {
            delete cleanOptions.page;
        }

        const query = new URLSearchParams(cleanOptions).toString();

        const pathname =
            typeof route === "string"
                ? route
                : route.pathname;

        const finalRoute = query ? `${pathname}?${query}` : pathname;
        // TODO: article because of this
        if (categoryState?.category?.length != 0 && !staticPage) {
            try {
                safePush(finalRoute, undefined, true);

                e?.preventDefault();
                // Trigger data fetching for the next page
                dispatch({
                    type: actions.SET_LOADER,
                    payload: { key: 'fetchingCategory', value: true }
                })
                const products = await getProducts(pathname, options?.page || null)
                const newProducts = products?.products;
                const data = {
                    ...products,
                    products: newProducts,
                    newRoute: route
                }
                dispatch({
                    type: actions.SET_CATEGORY,
                    payload: data
                })

                dispatch({
                    type: actions.SET_LOADER,
                    payload: { key: 'fetchingCategory', value: false }
                })
                dispatch({
                    type: globalActions.SET_GLOBAL_DATA,
                    payload: {
                        breadcrumbs: products.breadcrumb,
                        sidenav: products?.template_page_settings?.sidenav == 'yes' && template_settings.sidenav == 'yes'
                    }
                })

            } catch (error) {
                console.log(error)
            }
        }
        else {
            safePush('/' + finalRoute);
        }
    };



    return {
        handleShallowLink
    }
}

export default useCategoryShallowLink;